// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../icon/external.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Compat (global) */

:host {
  --compat-background-primary: var(
    --color-background-primary,
    light-dark(#ffffff, #1b1b1b)
  );
  --compat-background-secondary: var(
    --color-background-secondary,
    light-dark(#f9f9fb, #313131)
  );
  --compat-border-primary: var(
    --color-border-primary,
    light-dark(#cdcdcd, #858585)
  );
  --compat-border-secondary: var(
    --color-border-secondary,
    light-dark(#cdcdcd, #696969)
  );

  /* --compat-border (internal) */

  /* --compat-browser-count (internal) */
  --compat-code-background-inline: var(
    --code-background-inline,
    light-dark(#f2f1f1, #343434)
  );
  --compat-elem-radius: var(--elem-radius, 0.25rem);
  --compat-icon-critical: var(--icon-critical, light-dark(#d30038, #ff707f));
  --compat-icon-information: var(
    --icon-information,
    light-dark(#0085f2, #5e9eff)
  );
  --compat-icon-primary: var(--icon-primary, light-dark(#696969, #ffffff));
  --compat-icon-secondary: var(--icon-secondary, light-dark(#b3b3b3, #b3b3b3));
  --compat-icon-success: var(--icon-success, light-dark(#007936, #00b755));

  /* --compat-padding-bottom-offset (internal) */
  --compat-text-link: var(--color-text-link, light-dark(#0069c2, #8cb4ff));
  --compat-text-primary-blue: var(
    --color-text-primary-blue,
    light-dark(#0069c2, #8cb4ff)
  );
  --compat-text-primary-green: var(
    --color-text-primary-green,
    light-dark(#007936, #00d061)
  );
  --compat-text-primary-red: var(
    --color-text-primary-red,
    light-dark(#d30038, #ff97a0)
  );
  --compat-text-primary-yellow: var(
    --color-text-primary-yellow,
    light-dark(#746a00, #c7b700)
  );
  --compat-text-primary: var(
    --color-text-primary,
    light-dark(#1b1b1b, #ffffff)
  );
  --compat-type-smaller-font-size: var(--type-smaller-font-size, 0.833rem);
}

* {
  box-sizing: border-box;
  overflow-wrap: break-word;
}

/* Remove default margin */
body,
h1,
h2,
h3,
h4,
p,
figure,
blockquote,
dl,
dd {
  margin: 0;
}

.visually-hidden {
  position: absolute !important;

  width: 1px !important;
  height: 1px !important;

  padding: 0 !important;
  margin: -1px !important;

  overflow: hidden !important;

  white-space: nowrap !important;

  border: 0 !important;

  clip: rect(1px, 1px, 1px, 1px) !important;
  clip-path: inset(50%) !important;
}

code {
  width: fit-content;
  padding: 0.125rem 0.25rem;
  background: var(--compat-code-background-inline);
}

a {
  color: var(--compat-text-link);
}

button {
  appearance: none;
  background: none;
  border: medium;
}

.external::after {
  display: inline-flex;

  width: 10px;
  height: 10px;

  margin-left: 4px;

  content: "";

  background-color: var(--compat-icon-primary);

  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask-size: cover;
}
`, "",{"version":3,"sources":["webpack://./components/compat/global.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;;EAED,+BAA+B;;EAE/B,sCAAsC;EACtC;;;GAGC;EACD,iDAAiD;EACjD,0EAA0E;EAC1E;;;GAGC;EACD,wEAAwE;EACxE,4EAA4E;EAC5E,wEAAwE;;EAExE,8CAA8C;EAC9C,wEAAwE;EACxE;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD,wEAAwE;AAC1E;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;;;;;;;;;;EAUE,SAAS;AACX;;AAEA;EACE,6BAA6B;;EAE7B,qBAAqB;EACrB,sBAAsB;;EAEtB,qBAAqB;EACrB,uBAAuB;;EAEvB,2BAA2B;;EAE3B,8BAA8B;;EAE9B,oBAAoB;;EAEpB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;;EAEpB,WAAW;EACX,YAAY;;EAEZ,gBAAgB;;EAEhB,WAAW;;EAEX,4CAA4C;;EAE5C,mDAAuC;EACvC,gBAAgB;AAClB","sourcesContent":["/* Compat (global) */\n\n:host {\n  --compat-background-primary: var(\n    --color-background-primary,\n    light-dark(#ffffff, #1b1b1b)\n  );\n  --compat-background-secondary: var(\n    --color-background-secondary,\n    light-dark(#f9f9fb, #313131)\n  );\n  --compat-border-primary: var(\n    --color-border-primary,\n    light-dark(#cdcdcd, #858585)\n  );\n  --compat-border-secondary: var(\n    --color-border-secondary,\n    light-dark(#cdcdcd, #696969)\n  );\n\n  /* --compat-border (internal) */\n\n  /* --compat-browser-count (internal) */\n  --compat-code-background-inline: var(\n    --code-background-inline,\n    light-dark(#f2f1f1, #343434)\n  );\n  --compat-elem-radius: var(--elem-radius, 0.25rem);\n  --compat-icon-critical: var(--icon-critical, light-dark(#d30038, #ff707f));\n  --compat-icon-information: var(\n    --icon-information,\n    light-dark(#0085f2, #5e9eff)\n  );\n  --compat-icon-primary: var(--icon-primary, light-dark(#696969, #ffffff));\n  --compat-icon-secondary: var(--icon-secondary, light-dark(#b3b3b3, #b3b3b3));\n  --compat-icon-success: var(--icon-success, light-dark(#007936, #00b755));\n\n  /* --compat-padding-bottom-offset (internal) */\n  --compat-text-link: var(--color-text-link, light-dark(#0069c2, #8cb4ff));\n  --compat-text-primary-blue: var(\n    --color-text-primary-blue,\n    light-dark(#0069c2, #8cb4ff)\n  );\n  --compat-text-primary-green: var(\n    --color-text-primary-green,\n    light-dark(#007936, #00d061)\n  );\n  --compat-text-primary-red: var(\n    --color-text-primary-red,\n    light-dark(#d30038, #ff97a0)\n  );\n  --compat-text-primary-yellow: var(\n    --color-text-primary-yellow,\n    light-dark(#746a00, #c7b700)\n  );\n  --compat-text-primary: var(\n    --color-text-primary,\n    light-dark(#1b1b1b, #ffffff)\n  );\n  --compat-type-smaller-font-size: var(--type-smaller-font-size, 0.833rem);\n}\n\n* {\n  box-sizing: border-box;\n  overflow-wrap: break-word;\n}\n\n/* Remove default margin */\nbody,\nh1,\nh2,\nh3,\nh4,\np,\nfigure,\nblockquote,\ndl,\ndd {\n  margin: 0;\n}\n\n.visually-hidden {\n  position: absolute !important;\n\n  width: 1px !important;\n  height: 1px !important;\n\n  padding: 0 !important;\n  margin: -1px !important;\n\n  overflow: hidden !important;\n\n  white-space: nowrap !important;\n\n  border: 0 !important;\n\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  clip-path: inset(50%) !important;\n}\n\ncode {\n  width: fit-content;\n  padding: 0.125rem 0.25rem;\n  background: var(--compat-code-background-inline);\n}\n\na {\n  color: var(--compat-text-link);\n}\n\nbutton {\n  appearance: none;\n  background: none;\n  border: medium;\n}\n\n.external::after {\n  display: inline-flex;\n\n  width: 10px;\n  height: 10px;\n\n  margin-left: 4px;\n\n  content: \"\";\n\n  background-color: var(--compat-icon-primary);\n\n  mask-image: url(\"../icon/external.svg\");\n  mask-size: cover;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
